// Defensive mappers for the owner endpoints.

import type { OwnerView, UserOptionView } from './types';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function asString(value: unknown, fallback = ''): string {
  return typeof value === 'string' ? value : fallback;
}

function asNullableString(value: unknown): string | null {
  return typeof value === 'string' ? value : null;
}

export function toOwnerView(raw: unknown): OwnerView | null {
  if (!isRecord(raw)) return null;
  const id = raw.id;
  const agentId = raw.agent_id;
  const userId = raw.user_id;
  if (typeof id !== 'string' || id.length === 0) return null;
  if (typeof agentId !== 'string' || agentId.length === 0) return null;
  if (typeof userId !== 'string' || userId.length === 0) return null;
  return {
    id,
    agentId,
    userId,
    assignedBy: asString(raw.assigned_by),
    isPrimary: raw.is_primary === true,
    email: asNullableString(raw.email),
    displayName: asNullableString(raw.display_name),
    createdAt: asString(raw.created_at),
  };
}

export function toOwnerViewList(raw: unknown): OwnerView[] {
  if (!isRecord(raw)) return [];
  const owners = Array.isArray(raw.owners) ? raw.owners : [];
  return owners.map(toOwnerView).filter((o): o is OwnerView => o !== null);
}

export function toUserOptionView(raw: unknown): UserOptionView | null {
  if (!isRecord(raw)) return null;
  const userId = raw.user_id;
  if (typeof userId !== 'string' || userId.length === 0) return null;
  return {
    userId,
    email: asString(raw.email),
    displayName: asString(raw.display_name),
  };
}

export function toUserOptionList(raw: unknown): UserOptionView[] {
  if (!isRecord(raw)) return [];
  const users = Array.isArray(raw.users) ? raw.users : [];
  return users.map(toUserOptionView).filter((u): u is UserOptionView => u !== null);
}
